<div class="bounce">
    <div [style.background-color]="color"></div>
    <div [style.background-color]="color"></div>
    <div [style.background-color]="color"></div>
</div>

